// extracted by mini-css-extract-plugin
export default {"radio":"SuperRadio_radio__ydAWs","label":"SuperRadio_label__ebgvd","options":"SuperRadio_options__F40gm"};